import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { 
  TrendingUp,
  DollarSign,
  Activity,
  FileText
} from 'lucide-react';
import { 
  Card, 
  Statistic, 
  Row,
  Col
} from 'antd';
import DashboardLayout from '../components/layout/DashboardLayout';

const Dashboard = () => {
  const { user } = useAuth();
  const [stats, setStats] = useState({
    totalTransactions: 45,
    totalDebit: 2500000,
    totalCredit: 3200000,
    currentBalance: 700000
  });
  const headerActions = null;

  const StatCard = ({ icon: Icon, title, value, color, prefix = '' }) => (
    <Card className="hover:shadow-lg transition-shadow">
      <div className="flex items-center justify-between">
        <div>
          <Statistic
            title={title}
            value={value}
            prefix={prefix}
            valueStyle={{ color: '#1f2937', fontWeight: 'bold' }}
          />
        </div>
        <div className={`p-3 rounded-lg ${color}`}>
          <Icon className="w-6 h-6 text-white" />
        </div>
      </div>
    </Card>
  );

  return (
    <DashboardLayout  title="Dashboard" 
    subtitle={`Welcome back, ${user?.name}!`}
    headerActions={headerActions}>
      <div className="space-y-6 m-8">
        {/* Welcome section */}
        <div>
          <h2 className="text-lg font-medium text-gray-800 mb-2">
            Welcome back, {user?.name}!
          </h2>
          <p className="text-gray-600">
            Here's your account summary and key metrics.
          </p>
        </div>

        {/* Stats grid */}
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} lg={6}>
            <StatCard
              icon={FileText}
              title="Total Transactions"
              value={stats.totalTransactions}
              color="bg-blue-500"
            />
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <StatCard
              icon={TrendingUp}
              title="Total Credit"
              value={stats.totalCredit.toLocaleString()}
              prefix="₹"
              color="bg-green-500"
            />
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <StatCard
              icon={Activity}
              title="Total Debit"
              value={stats.totalDebit.toLocaleString()}
              prefix="₹"
              color="bg-red-500"
            />
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <StatCard
              icon={DollarSign}
              title="Current Balance"
              value={Math.abs(stats.currentBalance).toLocaleString()}
              prefix="₹"
              color={stats.currentBalance >= 0 ? "bg-green-600" : "bg-red-600"}
            />
          </Col>
        </Row>

        {/* Charts */}
        <Row gutter={[16, 16]}>
          <Col xs={24} lg={12}>
            <Card title="Monthly Transaction Trend" className="h-80">
              <div className="flex items-center justify-center h-full text-gray-500">
                <div className="text-center">
                  <TrendingUp className="w-12 h-12 mx-auto mb-4 opacity-50" />
                  <p>Chart coming soon...</p>
                </div>
              </div>
            </Card>
          </Col>
          <Col xs={24} lg={12}>
            <Card title="Account Balance Over Time" className="h-80">
              <div className="flex items-center justify-center h-full text-gray-500">
                <div className="text-center">
                  <DollarSign className="w-12 h-12 mx-auto mb-4 opacity-50" />
                  <p>Chart coming soon...</p>
                </div>
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </DashboardLayout>
  );
};

export default Dashboard;